import axios from "axios";
import { getCookie, eraseCookie } from "./cookies";
import { ShowErrorToast } from "./toastMessage";

const URL = process.env.REACT_APP_API_BASE_URL;

const axiosClient = axios.create({
  baseURL: URL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const axiosClientUpload = axios.create({
  baseURL: URL,
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

const axiosLogin = axios.create({
  baseURL: URL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

function setAxiosClientInterceptor() {
  axiosClient.interceptors.request.use((req) => {
    let token = getCookie("coach_token");
    if (!token) {
      return req;
    }
    req.headers.Authorization = `${token}`;

    return req;
  });

  axiosClient.interceptors.response.use(
    (res) => res,
    async (error) => {
      const originalRequest = error.config;

      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;

        // Clear the token if it is invalid
        eraseCookie("coach_token");
        if (error.response.status === 401) {
          ShowErrorToast("error", "Session Expired, please login again.");

          setTimeout(() => {
            window.location.href = "/login"; // Replace with your actual login page path
          }, 2000); // Adjust the delay time as needed (2000ms = 2 seconds)
        }
        return Promise.reject(error);
      }

      console.log(error.response);

      // Show API error message if available
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;

        // Handle non_field_errors
        if (errors.non_field_errors && Array.isArray(errors.non_field_errors)) {
          errors.non_field_errors.forEach((errorMessage: string) => {
            ShowErrorToast("error", errorMessage);
          });
        } else {
          // Handle other field-specific errors
          Object.keys(errors).forEach((field) => {
            if (Array.isArray(errors[field])) {
              errors[field].forEach((errorMessage: string) => {
                ShowErrorToast("error", `${field}: ${errorMessage}`);
              });
            }
          });
        }
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        ShowErrorToast("error", error.response.data.message);
      } else if (error.response?.data?.error) {
        ShowErrorToast("error", error.response.data.error);
      } else {
        // Fallback error message
        ShowErrorToast("error", "An unexpected error occurred.");
      }

      return Promise.reject(error);
    },
  );

  axiosClientUpload.interceptors.request.use((req) => {
    let token = getCookie("coach_token");
    if (!token) {
      return req;
    }
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });
}

export {
  axiosClient,
  axiosLogin,
  setAxiosClientInterceptor,
  axiosClientUpload,
};
